import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type {
	CampaignBanner,
	InFlightBillet,
	StandRow,
	TrendDisplayData,
} from "../models/TrendDisplay";

export const getTrendDisplay = async ({
	signal,
}: {
	signal?: AbortSignal;
}): Promise<TrendDisplayData> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2(
		"[MILL].[GetTrendDisplayDataWeb]",
		[],
		signal,
	);

	if (resp.ok) {
		const stands = get(resp, "data.tables[0].rows", []) as StandRow[];
		const banner = get(
			resp,
			"data.tables[1].rows[0]",
			null,
		) as CampaignBanner | null;
		// Result set #3: one row per in-flight billet; empty when none are on the line
		const inFlightBillets = get(
			resp,
			"data.tables[2].rows",
			[],
		) as InFlightBillet[];
		return { stands, banner, inFlightBillets };
	}
	throw new Error(resp.message || "Error fetching trend display");
};
